<template>
    <div class="card">
        <div class="card-body">
            <template v-if="editing">
                <b-form-radio-group
                    class="cursus-radios cursus-radios--fw-normal text-lowercase"
                    :checked="value.account_type"
                    @change="handleChanged"
                >
                    <OrganizationAccountTypeRadio
                        class="mb-3"
                        value="organization"
                    />
                    <PersonalAccountTypeRadio
                        value="personal"
                    />
                </b-form-radio-group>
            </template>
            <template v-else>
                <div class="row align-items-center">
                    <div class="col">
                        <template v-if="value.account_type === 'organization'">
                            en tant que <strong>salarié</strong>,
                            <strong>agent</strong>,
                            <strong>élu</strong> ou
                            <strong>bénévole</strong>
                            <span class="cursus-radios__help mt-1">
                                d’une structure (équipe artistique, lieu de diffusion, festival, ...) / d’une collectivité / d’un établissement public
                            </span>
                        </template>
                        <template v-else>
                            en tant que  <strong>professionnel indépendant</strong> ou <strong>étudiant</strong>
                            <span class="cursus-radios__help mt-1">
                                (auto-entrepreneur / auteur-réalisateur / artiste / demandeur d’emploi / intermittent / ...)
                            </span>
                        </template>
                    </div>
                    <div class="col-auto">
                        <button class="btn btn-link btn-sm" @click="handleEditClicked">
                            Modifier...
                        </button>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import OrganizationAccountTypeRadio from "./OrganizationAccountTypeRadio";
    import PersonalAccountTypeRadio from "./PersonalAccountTypeRadio";
    export default {
        components: {
            PersonalAccountTypeRadio,
            OrganizationAccountTypeRadio,
        },
        props: {
            value: Object,
            editing: Boolean,
        },
        methods: {
            handleChanged(value) {
                this.$emit('input', {
                    ...this.value,
                    account_type: value,
                });
            },
            handleEditClicked() {
                this.$emit('update:editing', true);
            },
        },
    }
</script>
